import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/button';

const WHATSAPP_NUMBER = '6287886815136';

export const Pricing = () => {
  const plans = [
    {
      name: 'Shared Tier 1',
      tagline: 'Untuk kompleks dengan warga hingga 100 orang',
      features: [
        'Pengelolaan iuran otomatis',
        'Notifikasi pembayaran via Apps',
        'Laporan keuangan dasar',
        'Support email',
        'Database warga',
        '1 Admin user'
      ],
      popular: false,
    },
    {
      name: 'Shared Tier 2',
      tagline: 'Untuk kompleks dengan warga di atas 300 orang',
      features: [
        'Semua fitur Shared Tier 1',
        'Notifikasi via WhatsApp, Email & Apps',
        'Laporan keuangan advanced',
        'Support prioritas',
        'Unlimited admin users',
        'Custom branding'
      ],
      popular: true,
    },
    {
      name: 'Dedicated',
      tagline: 'Server & database terpisah untuk skala besar / kebutuhan khusus',
      features: [
        'Semua fitur Shared Tier 2',
        'Infrastruktur dedicated (bukan shared)',
        'Multiple kompleks dalam 1 akun',
        'API integration',
        'SLA & support 24/7',
        'Training & onboarding'
      ],
      popular: false,
    }
  ];

  const handleContact = (planName) => {
    const message = encodeURIComponent(`Halo, saya ingin tanya harga paket ${planName} Sistem IPL.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="pricing" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <div className="inline-block bg-gold-500/15 text-gold-600 px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
            🎉 Harga Spesial untuk Early Adopter
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
            Harga <span className="text-brand-700">Berlangganan</span>
          </h2>
          <p className="text-lg text-foreground/70">
            Pilih paket yang sesuai dengan kebutuhan kompleks Anda. Hubungi kami untuk penawaran harga.
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
          className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto"
        >
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } }}
              whileHover={{ y: plan.popular ? -4 : -2 }}
              className={`relative rounded-3xl p-8 transition-all duration-300 flex flex-col ${
                plan.popular
                  ? 'bg-gradient-to-br from-brand-50 to-gold-400/10 border-2 border-brand-600 shadow-2xl lg:scale-105'
                  : 'bg-card border-2 border-border hover:border-brand-300 hover:shadow-xl'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-brand-700 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Paling Populer
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-foreground mb-2">{plan.name}</h3>
                <p className="text-foreground/70 text-sm mb-6 min-h-10">{plan.tagline}</p>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="text-3xl font-bold text-brand-700">Hubungi Kami</span>
                </div>
                <p className="text-foreground/60 text-sm mt-2">Harga disesuaikan kebutuhan Anda</p>
              </div>

              <ul className="space-y-4 mb-8 flex-1">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                      <Check className="text-brand-600" size={20} />
                    </div>
                    <span className="text-foreground/80">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => handleContact(plan.name)}
                className={`w-full py-6 text-lg font-semibold ${
                  plan.popular
                    ? 'bg-brand-700 hover:bg-brand-800 text-white'
                    : 'bg-foreground hover:bg-foreground/90 text-background'
                }`}
              >
                Hubungi Kami
              </Button>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-12 text-center">
          <p className="text-foreground/70">
            Butuh paket khusus untuk kebutuhan enterprise? {' '}
            <a href="https://wa.me/6287886815136" target="_blank" rel="noopener noreferrer" className="text-brand-700 hover:text-brand-800 font-semibold">
              Hubungi kami
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};
